import { ErrorCode } from './errorMatcher'

class PlatformError extends Error {
  public readonly code: ErrorCode
  public readonly message: string
  public readonly details: Array<object>

  constructor(code: ErrorCode, message: string, details: [] = []) {
    super(message)
    this.code = code
    this.message = message
    this.details = details

    // Set the prototype explicitly to ensure instanceof works correctly
    Object.setPrototypeOf(this, PlatformError.prototype)
  }
}

export default PlatformError
